import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization_category`;

export function findOrganizationCategory(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
export function findOrganizationCategoryById(id) {
  return axios.get(`${URL}/${id}`);
}
export function createOrganizationCategory(payload) {
  return axios.post(`${URL}/create`, payload);
}
export function updateOrganizationCategory(payload) {
  return axios.put(`${URL}/update`, payload);
}
export function deleteOrganizationCategoryFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}
export function findAllOrgCategory() {
  return axios.get(`${URL}`);
}
